module.exports = __webpack_public_path__ + "img/univer-logo.014587fc.svg";